import designItem from './DesignDateTime.vue'
const DesignDateTime = {
  install: function (Vue) {
    Vue.component('DesignDateTime', designItem)
  }
}
export default DesignDateTime
